import React from "react";

interface TickIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const TickIcon = ({
                             className = "",
                             color = "currentColor",
                             size = "md",
                         }: TickIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",       // ~16x16px
        md: "w-4.5 h-4.5",   // ~18x18px
        lg: "w-6 h-6",       // ~24x24px
        xl: "w-8 h-8",       // ~32x32px
    };

    return (
        <div className="icon tick-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M20 6 9 17l-5-5" />
            </svg>
        </div>
    );
};

export default TickIcon;